var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./AdvertisingBanner.jinja');
require('./AdvertisingBanner.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        this.$('.AdvertisingBanner-banner').each(function () {
            var $banner = $(this);
            var params = JSON.parse($banner.attr('data-params'));
            var position = $banner.attr('data-position');
            var urlParts = [
                'LEADcategory=' + encodeURIComponent('Banner'),
                'LEADname=' + encodeURIComponent('Website Ads > ' + position + ' > ' + params.name),
                'LEADcust=' + encodeURIComponent(params.customer),
                'LEAD=' + encodeURIComponent(params.link)
            ];
            var url = Urls['front:advertising']() + '?' + urlParts.join('&');
            $banner.attr('href', url);
        });

        Base.prototype.initialize.call(this, options);

        var count = this.$('.AdvertisingBanner-banner').length;

        if (count > 1) {
            var active = 0;

            setInterval(function () {
                active = (active + 1) % count;
                this.$('.AdvertisingBanner-banner').removeClass('AdvertisingBanner-banner--active');
                this.$('.AdvertisingBanner-banner')
                    .eq(active)
                    .addClass('AdvertisingBanner-banner--active');
            }.bind(this), 6000);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/AdvertisingBanner/AdvertisingBanner.js
// module id = 86
// module chunks = 0